import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getDateWithoutTimezone, getTimeWithoutTimezone } from '../../common/helpers';
import { l10n } from '../../common/constants';
import {
  getPluginKey,
  getSeragamSize,
  PLUGIN_MISSION_TRIP,
  PLUGIN_SERAGAM,
} from '../form-builder/schemaRuntime';

const seragamExclusives = Array.from(
  { length: 20 },
  (_, index) => `seragam${index + 1}`
);
const MISSION_TRIP_GSC_EXCLUSIVE = "missiontripgsc";
const MISSION_TRIP_EXCLUSIVE = "missiontrip";

const getSeragamSizeLabel = (name = '') => name.replace(/\s*\[(.*?)\]\s*/g, '').trim();

export class EventSubItem extends Component {
  render() {
    const { name, start_date, price } = this.props.eventSub;
    const pluginKey = getPluginKey(this.props.event);
    const isSeragamEvent =
      seragamExclusives.includes(this.props.event.exclusive) ||
      pluginKey === PLUGIN_SERAGAM;
    const isMissionTripEvent =
      this.props.event.exclusive === MISSION_TRIP_EXCLUSIVE ||
      pluginKey === PLUGIN_MISSION_TRIP;
    const language = this.props.language || "ind";
    const priceUnit = isSeragamEvent
      ? "pcs"
      : this.props.event.exclusive === MISSION_TRIP_GSC_EXCLUSIVE
        ? "Room"
        : isMissionTripEvent
          ? "Paket / Orang"
        : "Person";

    if (isSeragamEvent) {
      return (
        <div style={divStyle}>
          <button
            className="btn btn-block btn-select text-left seragam-subitem"
            onClick={this.props.selectEvent.bind(this, this.props.event, this.props.eventSub)}
            style={seragamButtonStyle}
          >
            <div className="seragam-subitem__inner">
              <div
                className="seragam-subitem__bar"
                style={{ backgroundColor: `#${this.props.eventSub.ticket_color_hex}` }}
              />
              <div className="seragam-subitem__body">
                <div className="seragam-subitem__top">
                  <div className="seragam-subitem__heading">
                    <div className="seragam-subitem__size">{pluginKey === PLUGIN_SERAGAM ? getSeragamSize(this.props.eventSub) : getSeragamSizeLabel(name)}</div>
                  </div>
                  {this.props.event.is_paid ? (
                    <div className="seragam-subitem__pricing">
                      <div className="seragam-subitem__price">IDR {price.toLocaleString()}</div>
                      <div className="seragam-subitem__unit">{l10n.seragamPriceUnit[language]}</div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </button>
        </div>
      )
    }

    if (isMissionTripEvent) {
      return (
        <div style={divStyle}>
          <button
            className="btn btn-block btn-select text-left mission-trip-subitem"
            onClick={this.props.selectEvent.bind(this, this.props.event, this.props.eventSub)}
            style={missionTripButtonStyle}
          >
            <div style={missionTripInnerStyle}>
              <div style={{ ...missionTripAccentStyle, backgroundColor: `#${this.props.eventSub.ticket_color_hex}` }} />
              <div style={missionTripBodyStyle}>
                <div style={missionTripTitleStyle}>{name}</div>
                {this.props.event.is_paid ? (
                  <div>
                    <span style={priceStyle}>IDR {price.toLocaleString()}</span>
                    <span style={pricePersonStyle}>/ {priceUnit}</span>
                  </div>
                ) : null}
              </div>
            </div>
          </button>
        </div>
      )
    }

    return (
      <div style={divStyle}>
        <button
          className="btn btn-outline-secondary btn-block btn-select text-left"
          onClick={this.props.selectEvent.bind(this, this.props.event, this.props.eventSub)}
          style={buttonStyle}
        >
          <div className="container-fluid">
            <div className="row">
              <div className="col-1" style={{ padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ ...calendarStyle, backgroundColor: `#${this.props.eventSub.ticket_color_hex}` }} />
              </div>
              <div className="col-11">
                {!isMissionTripEvent && (
                  <div style={infoStyle}>
                    {getDateWithoutTimezone(start_date)} &#x2022; {getTimeWithoutTimezone(start_date)}
                  </div>
                )}
                <div style={titleStyle}>{name}</div>
                {this.props.event.is_paid ? (
                  <div>
                  <span style={priceStyle}>IDR {price.toLocaleString()}</span> 
                  <span style={pricePersonStyle}>/  {priceUnit}</span></div> 
                ) : null}
              </div>
            </div>
          </div>
        </button>
      </div>
    )
  }
}

// PropTypes
EventSubItem.propTypes = {
  eventSub: PropTypes.object.isRequired,
  event: PropTypes.object.isRequired,
  language: PropTypes.string,
  selectEvent: PropTypes.func.isRequired,
}

// Styles
const buttonStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  verticalAlign: 'middle',
  fontSize: '1.0rem',
  marginBottom: '7px',
  borderRadius: '6px',
  borderColor: '#adb5bd'
}
const seragamButtonStyle = {
  marginBottom: '0',
  border: 'none',
}
const missionTripButtonStyle = {
  backgroundColor: '#ffffff',
  border: '1px solid #d4dbe5',
  borderRadius: '8px',
  color: '#18212f',
  marginBottom: '10px',
  padding: '0',
  boxShadow: '0 1px 3px rgba(24, 39, 75, 0.06)',
}
const missionTripInnerStyle = {
  display: 'flex',
  alignItems: 'stretch',
  minHeight: '96px',
}
const missionTripAccentStyle = {
  width: '12px',
  minWidth: '12px',
  margin: '16px 0 16px 16px',
  borderRadius: '999px',
}
const missionTripBodyStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: '14px',
  padding: '16px 16px 16px 18px',
}
const missionTripTitleStyle = {
  color: '#111827',
  fontSize: '1rem',
  fontWeight: 'bold',
  lineHeight: '1.25',
}
const divStyle = {
  width: '100%'
}
const calendarStyle = {
  padding: '0',
  borderRadius: '6px',
  height: '70%',
  width: '15px'
}
const infoStyle = {
  color: '#423f40',
  fontSize: '0.85rem',
}
const titleStyle = {
  fontSize: '1rem',
  fontWeight: 'bold',
  marginBottom: '18px'
}
const priceStyle = {
  fontSize: '0.9rem',
  color: '#dc3545',
}
const pricePersonStyle = {
  color: '#423f40',
  fontSize: '0.7rem',
}

export default EventSubItem
